import {lazy} from "react";

export const HistorySingleVoyageLazy = lazy(() => import('./HistorySingleVoyage'))